import React from 'react';
import SvgIcon from './SvgIcon';
import { SvgIconProps } from './types';

const PercentIcon = (props: SvgIconProps) => (
    <SvgIcon
        {...props}
        viewBox="0 0 256 256"
        width="25"
        height="25"
        id="IconChangeColor"
    >
        <rect width="256" height="256" fill="none" />
        <line
            x1="200"
            y1="56"
            x2="56"
            y2="200"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="12"
        />
        <circle
            cx="76"
            cy="76"
            r="28"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="12"
        />
        <circle
            cx="180"
            cy="180"
            r="28"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="12"
        />
    </SvgIcon>
);

export default PercentIcon;
